import { FC, useEffect } from 'react';
import { useTranslation } from '@jobcost-monorepo/i18n';
import { Button, InputForm } from '@jobcost-monorepo/ui';
import { useFormContext } from 'react-hook-form';
import React from 'react';

const UserPasswordComponent: FC = () => {
  const passwordDefault = 'Nurale2024!';
  const { t } = useTranslation('users');
  const { setValue, watch } = useFormContext();
  const id = watch('id');

  const generateRandomPassword = (): void => {
    const lowerCaseLetters = 'abcdefghijklmnopqrstuvwxyz';
    const upperCaseLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const numbers = '0123456789';
    const specialCharacters = '!@#$%^&*()_+~`|}{[]:;?><,./-=';

    const passwordLength = 8;

    const password = Array(passwordLength)
      .fill(null)
      .map(() => {
        const randomIndex = Math.floor(Math.random() * 4);

        switch (randomIndex) {
          case 0:
            return lowerCaseLetters[
              Math.floor(Math.random() * lowerCaseLetters.length)
            ];
          case 1:
            return upperCaseLetters[
              Math.floor(Math.random() * upperCaseLetters.length)
            ];
          case 2:
            return numbers[Math.floor(Math.random() * numbers.length)];
          case 3:
            return specialCharacters[
              Math.floor(Math.random() * specialCharacters.length)
            ];
          default:
            return null;
        }
      })
      .join('');

    setValue('password', password);
    setValue('passwordConfirm', password);
  };

  useEffect(() => {
    setValue('password', passwordDefault);
    setValue('passwordConfirm', passwordDefault);
  }, []);

  return id ? (
    <div />
  ) : (
    <div className="flex justify-center align-middle space-x-4 w-full">
      <InputForm
        name="password"
        errorName="password"
        label={t('form.password')}
        type="text"
        width="w-full"
      />
      <div className="flex flex-col justify-center align-middle w-full">
        <Button type="button" onClick={generateRandomPassword}>
          {t('form.generateRandomPassword')}
        </Button>
      </div>
      <InputForm
        name="passwordConfirm"
        errorName="passwordConfirm"
        label={t('form.passwordConfirm')}
        type="text"
        width="w-full"
      />
    </div>
  );
};

export default UserPasswordComponent;
